// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useState, useEffect } from "react";
import { Modal, Select, Input } from "antd";
import "../style.css";
import {
  WorkerStages,
  WORKER_STAGES_REASONS_DATA,
  WORKER_STAGES_REASONS,
  WorkerSubstages,
} from "../../../appV2/redesign/utils/worker";

const { Option } = Select;
const { TextArea } = Input;

const StagesData = {
  [WorkerStages.PROBATION]: {
    title: "Put Professional on Probation",
    buttonText: "Put On Probation",
  },
  [WorkerStages.RESTRICTED]: {
    title: "Restrict Professional",
    buttonText: "Restrict",
  },
  [WorkerStages.DEACTIVATED]: {
    title: "Deactivate Professional",
    buttonText: "Deactivate",
  },
  [WorkerSubstages.INVITE_REQUIRED]: {
    title: "Set Professional to Invite-Required",
    buttonText: "Make Invite-Required",
  },
};

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'stage' implicitly has an 'any' type.
function WorkerStagesModal({ stage, substage, isVisible, onAccept, onCancel }) {
  const [reason, setReason] = useState(null);
  const [note, setNote] = useState(null);
  const [confirmationModalVisibility, setConfirmationModalVisibility] = useState(false);
  const [stageChangeModalVisibility, setStageChangeModalVisibility] = useState(isVisible);

  useEffect(() => {
    setReason(null);
    setNote(null);
    setStageChangeModalVisibility(isVisible);
  }, [isVisible]);

  const requireConfirmation = [
    WorkerStages.DEACTIVATED,
    WorkerStages.RESTRICTED,
    WorkerSubstages.INVITE_REQUIRED,
  ].includes(stage);

  const onPreConfirm = () => {
    setConfirmationModalVisibility(true);
    setStageChangeModalVisibility(false);
  };

  const onConfirm = () => {
    setConfirmationModalVisibility(false);
    onAccept(stage, substage, reason, note);
  };

  const onConfirmCancel = () => {
    setConfirmationModalVisibility(false);
    onCancel.call();
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'selectedReason' implicitly has an 'any' type.
  const onReasonChange = (selectedReason) => {
    setReason(selectedReason);
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'event' implicitly has an 'any' type.
  const onNoteChange = (event) => {
    setNote(event.target.value);
  };

  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'workerStage' implicitly has an 'any' type.
  function WarningModalTitle({ stage: workerStage }) {
    if (workerStage === WorkerStages.DEACTIVATED) {
      return (
        <>
          <em>
            Setting a professional to <strong>{workerStage}</strong> will remove them from all
            shifts and prevent them from seeing new shifts.
          </em>
          <strong>Are you sure?</strong>
        </>
      );
    } else if (workerStage === WorkerStages.RESTRICTED) {
      return (
        <>
          <em>
            Setting a professional to <strong>{workerStage}</strong> will remove them from all
            shifts. They will not be able to book new shifts until the restriction is lifted.
          </em>
          <strong> Are you sure?</strong>
        </>
      );
    } else if (workerStage === WorkerSubstages.INVITE_REQUIRED) {
      return (
        <>
          <em>
            Setting a professional to <strong>{workerStage}</strong> will remove all currently
            booked shifts. They will not be able to book new shifts unless they receive a shift
            invite. This limitation is indefinite; it will <strong>not</strong> be lifted
            automatically.
          </em>
          <strong> Are you sure?</strong>
        </>
      );
    }
    return null;
  }

  if (!stage) {
    return <></>;
  }

  const isOkButtonDisabled =
    !reason || (WORKER_STAGES_REASONS_DATA[stage][reason].mandatoryNote && !note);

  return (
    <>
      <Modal
        title={StagesData[stage].title}
        visible={stageChangeModalVisibility}
        okText={StagesData[stage].buttonText}
        okButtonProps={{
          disabled: isOkButtonDisabled,
          /* @ts-expect-error FIXME this wrong type */
          "data-testid": "stage-change-ok-button",
        }}
        cancelButtonProps={{
          /* @ts-expect-error FIXME this wrong type */
          "data-testid": "stage-change-cancel-button",
        }}
        onOk={requireConfirmation ? onPreConfirm : onConfirm}
        onCancel={onCancel}
        destroyOnClose={true}
      >
        <Select placeholder="Reason" onChange={onReasonChange} className="modal-stage-select">
          {WORKER_STAGES_REASONS[stage]
            .filter((stageReason) => !!WORKER_STAGES_REASONS_DATA[stage][stageReason])
            .map((stageReason) => (
              <Option key={stageReason} value={stageReason}>
                {WORKER_STAGES_REASONS_DATA[stage][stageReason].description}
              </Option>
            ))}
        </Select>
        <TextArea
          placeholder="Notes"
          rows={4}
          onChange={onNoteChange}
          data-testid="worker-stage-change-notes"
        />
      </Modal>
      <Modal
        title="Warning"
        visible={confirmationModalVisibility}
        onOk={onConfirm}
        okButtonProps={{
          /* @ts-expect-error FIXME this wrong type */
          "data-testid": "stage-change-warning-ok-button",
        }}
        onCancel={onConfirmCancel}
        destroyOnClose={true}
        okText="Yes"
        cancelText="No"
      >
        <WarningModalTitle stage={stage}></WarningModalTitle>
      </Modal>
    </>
  );
}

export { WorkerStagesModal };
